"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _noImportant = require("aphrodite/no-important");

var _Thumbnail = _interopRequireDefault(require("./Thumbnail"));

var _Arrow = _interopRequireDefault(require("./Arrow"));

var _theme = _interopRequireDefault(require("../theme"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var classes = _noImportant.StyleSheet.create({
  paginatedThumbnails: {
    bottom: _theme["default"].container.gutter.vertical,
    height: _theme["default"].thumbnail.size,
    padding: '0 50px',
    position: 'absolute',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    left: '50%',
    transform: 'translateX(-50%)'
  }
});

var arrowStyles = {
  height: _theme["default"].thumbnail.size + _theme["default"].thumbnail.gutter * 2,
  width: 40
};

var PaginatedThumbnails = /*#__PURE__*/function (_Component) {
  _inherits(PaginatedThumbnails, _Component);

  var _super = _createSuper(PaginatedThumbnails);

  function PaginatedThumbnails(props) {
    var _this;

    _classCallCheck(this, PaginatedThumbnails);

    _this = _super.call(this, props);
    _this.state = {
      hasCustomPage: false
    };
    _this.gotoPrev = _this.gotoPrev.bind(_assertThisInitialized(_this));
    _this.gotoNext = _this.gotoNext.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PaginatedThumbnails, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.currImg !== this.props.currImg) {
        this.setState({
          hasCustomPage: false
        });
      }
    } // ====================
    // Methods
    // ====================

  }, {
    key: "getFirst",
    value: function getFirst() {
      var _this$props = this.props,
          currImg = _this$props.currImg,
          offset = _this$props.offset;

      if (this.state.hasCustomPage) {
        return this.clampFirst(this.state.first);
      }

      return this.clampFirst(currImg - offset);
    }
  }, {
    key: "setFirst",
    value: function setFirst(event, newFirst) {
      var first = this.state.first;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (first === newFirst) return;
      this.setState({
        hasCustomPage: true,
        first: newFirst
      });
    }
  }, {
    key: "gotoPrev",
    value: function gotoPrev(event) {
      this.setFirst(event, this.getFirst() - this.props.offset);
    }
  }, {
    key: "gotoNext",
    value: function gotoNext(event) {
      this.setFirst(event, this.getFirst() + this.props.offset);
    }
  }, {
    key: "clampFirst",
    value: function clampFirst(value) {
      var _this$props2 = this.props,
          imgs = _this$props2.imgs,
          offset = _this$props2.offset;
      var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side

      if (value < 0) {
        return 0;
      } else if (value + totalCount > imgs.length) {
        // Too far
        return imgs.length - totalCount;
      } else {
        return value;
      }
    } // ====================
    // Renderers
    // ====================

  }, {
    key: "renderArrowPrev",
    value: function renderArrowPrev(theme) {
      var leftTitle = this.props.leftTitle;
      if (this.getFirst() <= 0) return null;
      return /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
        theme: theme,
        direction: "left",
        size: "small",
        icon: "arrowLeft",
        onClick: this.gotoPrev,
        style: arrowStyles,
        title: leftTitle,
        type: "button"
      });
    }
  }, {
    key: "renderArrowNext",
    value: function renderArrowNext(theme) {
      var _this$props3 = this.props,
          offset = _this$props3.offset,
          imgs = _this$props3.imgs,
          rightTitle = _this$props3.rightTitle;
      var totalCount = 2 * offset + 1;
      if (this.getFirst() + totalCount >= imgs.length) return null;
      return /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
        theme: theme,
        direction: "right",
        size: "small",
        icon: "arrowRight",
        onClick: this.gotoNext,
        style: arrowStyles,
        title: rightTitle,
        type: "button"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          imgs = _this$props4.imgs,
          currImg = _this$props4.currImg,
          onClickThumbnail = _this$props4.onClickThumbnail,
          offset = _this$props4.offset,
          theme = _this$props4.theme;
      var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side

      var thumbnails = [];
      var baseOffset = 0;

      if (imgs.length <= totalCount) {
        thumbnails = imgs;
      } else {
        // Try to center current image in list
        baseOffset = this.getFirst();
        thumbnails = imgs.slice(baseOffset, baseOffset + totalCount);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _noImportant.css)(classes.paginatedThumbnails)
      }, this.renderArrowPrev(theme), thumbnails.map(function (img, idx) {
        return /*#__PURE__*/_react["default"].createElement(_Thumbnail["default"], _extends({
          theme: theme,
          key: baseOffset + idx
        }, img, {
          index: baseOffset + idx,
          onClick: onClickThumbnail,
          active: baseOffset + idx === currImg
        }));
      }), this.renderArrowNext(theme));
    }
  }]);

  return PaginatedThumbnails;
}(_react.Component);

exports["default"] = PaginatedThumbnails;
PaginatedThumbnails.propTypes = {
  theme: _propTypes["default"].object,
  leftTitle: _propTypes["default"].string,
  rightTitle: _propTypes["default"].string,
  currImg: _propTypes["default"].number,
  imgs: _propTypes["default"].array,
  offset: _propTypes["default"].number,
  onClickThumbnail: _propTypes["default"].func.isRequired
};